import { Card } from "@blueprintjs/core";
import type { DatesSetArg, EventInput } from "@fullcalendar/core/index.js";
import pluginDayGrid from "@fullcalendar/daygrid";
import pluginInteration from "@fullcalendar/interaction";
import pluginList from "@fullcalendar/list";
import FullCalendar from "@fullcalendar/react";
import pluginRRule from "@fullcalendar/rrule";
import pluginTimeGrid from "@fullcalendar/timegrid";
import { useGetScheduledEventsQuery } from "@package/ui-gql/index-data-access";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  ITEM_GRID_PATH_NEW,
  SidebarEntryPath,
} from "../../../../constants/contants";
import {
  setSchedulerArgsCreate,
  setSchedulerSelectedEventId,
} from "../../../../store/slices/slice-scheduler";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { convertScheduledEventsToCalendarInputs } from "./calendar-utils";
import { SchedulerToolbar } from "./SchedulerToolbar";

export function SchedulerCalendar() {
  const dispatch = useAppDispatch();
  const selectedEventId = useAppSelector(
    (state) => state.scheduler.selectedEventId,
  );
  const [dateSetArg, setDateSetArg] = useState<DatesSetArg>();
  const [events, setEvents] = useState<EventInput[]>([]);

  const { search } = useLocation();
  const navigate = useNavigate();

  const { data: eventsData } = useGetScheduledEventsQuery({
    variables: {
      filter: {
        start_gte: dateSetArg?.startStr,
        start_lte: dateSetArg?.endStr,
      },
      page: 0,
      perPage: 1000,
    },
  });

  useEffect(
    function effectOnEventsDataChanged() {
      setEvents(
        convertScheduledEventsToCalendarInputs(
          eventsData?.items,
          selectedEventId,
        ),
      );
    },
    [eventsData?.items, selectedEventId],
  );

  return (
    <>
      <SchedulerToolbar />
      <div className="mt-4">
        <Card>
          <FullCalendar
            datesSet={(arg) => setDateSetArg(arg)}
            editable
            events={events}
            eventClick={(arg) => {
              dispatch(setSchedulerSelectedEventId(arg.event.id));
            }}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
            }}
            initialView="dayGridMonth"
            plugins={[
              pluginDayGrid,
              pluginInteration,
              pluginList,
              pluginRRule,
              pluginTimeGrid,
            ]}
            select={(arg) => {
              dispatch(setSchedulerSelectedEventId());
              dispatch(
                setSchedulerArgsCreate({
                  start: arg.startStr,
                  end: arg.endStr,
                }),
              );
              navigate(
                `/${SidebarEntryPath.scheduler}/${ITEM_GRID_PATH_NEW}${search}`,
              );
            }}
            selectable
            selectMirror
          />
        </Card>
      </div>
    </>
  );
}
